
import obesidad from "../images/obesidad.svg"
import sobrepeso from "../images/sobrepeso.svg"
import normal from "../images/normal.svg"
import delgado from "../images/delgado.svg"
import obesidad_trans from "../images/obesidad_trans.svg"
import sobrepeso_trans from "../images/sobrepeso_trans.svg"
import delgado_trans from "../images/delgado_trans.svg"
import normal_trans from "../images/normal_trans.svg"
import { IonCard, IonCardHeader, IonCardTitle, IonProgressBar, IonCardContent, IonRow, IonCol, IonGrid, IonCardSubtitle, IonText, IonIcon } from "@ionic/react";
import { heartHalf } from "ionicons/icons"

export interface IValorImc{
    min:number,
    max:number,
    nombre:string,
    variant:string,
    pos:number,
    img:string,
    img_trans:string
}

export const tabla_imc = {
    M: [
      {min:0,max:19.999,nombre:"Bajo peso",variant:"secondary",pos:20,img:delgado,img_trans:delgado_trans},
      {min:20,max:24.999,nombre:"Peso normal",variant:"success",pos:5,img:normal,img_trans:normal_trans},
      {min:25,max:29.999,nombre:"Sobrepeso",variant:"warning",pos:5,img:sobrepeso,img_trans:sobrepeso_trans},
      {min:30,max:10000,nombre:"Obesidad",variant:"danger",pos:20,img:obesidad,img_trans:obesidad_trans}
    ] as Array<IValorImc>,
    F:[
      {min:0,max:19.999,nombre:"Bajo peso",variant:"secondary",pos:20,img:delgado,img_trans:delgado_trans},
      {min:20,max:23.999,nombre:"Peso normal",variant:"success",pos:4,img:normal,img_trans:normal_trans},
      {min:24,max:28.999,nombre:"Sobrepeso",variant:"warning",pos:5,img:sobrepeso,img_trans:sobrepeso_trans},
      {min:29,max:10000,nombre:"Obesidad",variant:"danger",pos:21,img:obesidad,img_trans:obesidad_trans}
    ] as Array<IValorImc>
  }
  
  export const PanelResumen:React.FC<{imc:number,genero:"M"|"F",valor_imc?:IValorImc,className?:string}> = (props) => {
    const {imc,genero,valor_imc} = props
    return (
        <IonCard className={props.className}>
            <IonCardHeader>
                <IonCardTitle className="ion-text-center"><h3><IonIcon icon={heartHalf} /> Imc Actual: <b>{imc.toFixed(2)}</b></h3></IonCardTitle>
                <IonCardSubtitle className="ion-text-center">Estos valores se calculan con tus datos registrados</IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
                <IonProgressBar color="primary" value={0.45} style={{marginBottom:2,height:10}} buffer={((imc>50?50:imc)*2)/100} />
                <div style={{width:"100%",height:10}}>
                {
                    tabla_imc[genero||"M"].map((tab,i) => (
                        <div style={{width:(tab.pos*2)+"%",display:"inline-block",float:"left"}} key={i}>
                            <IonProgressBar color={tab.variant} value={tab.pos*2} style={{height:10}} />
                        </div>
                    ))
                }
                </div>
                <IonGrid>
                    <IonRow>
                        {
                            tabla_imc[genero||"M"].map((tab,i:number) => (
                                <IonCol size="3" key={i}>
                                    {valor_imc?.variant==tab.variant?<img src={tab.img} style={{filter:"drop-shadow(0 0 5px yellow)"}} className="img-fluid" width={30} />:<img src={tab.img_trans} className="img-fluid" width={30} />}
                                </IonCol>
                            ))
                        }
                    </IonRow>
                </IonGrid>
                {
                    tabla_imc[genero||"M"].map((tab,i) => (
                        valor_imc?.variant==tab.variant?<p style={{textAlign:"center"}} key={i}>Tienes: <b><IonText color={valor_imc.variant}>{tab.nombre}</IonText></b></p>:null
                    ))
                }
            </IonCardContent>
        </IonCard>
    )
  }
  